// Minimal event-based toast bus. Any code can call `toast(...)`; the
// <Toaster /> mounted in App listens and renders the stack.
export const TOAST_EVENT = 'app-toast'

let counter = 0

export function toast(message, type = 'success') {
  counter += 1
  window.dispatchEvent(
    new CustomEvent(TOAST_EVENT, {
      detail: { id: counter, message, type },
    })
  )
}
